import React, {useEffect, lazy, Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

const App = lazy(() => import('./App'));
const AppArticle = lazy(() => import('./AppArticle'));

const DataPointsEntry = () => {
  useEffect(() => {
    window.appEventData = window.appEventData || {push:console.log};
  }, []);

  // if (process.env.BUILD_MODE !== "production") {
  //   const head = document.getElementsByTagName("head")[0];
  //   const link = document.createElement("link");
  //   link.rel = "stylesheet";
  //   link.href =
  //     "https://www.mckinsey.com/redesign/resources/css/styles-2dd554.css";
  //   head.appendChild(link);
  //   reportWebVitals();
  // }

  // if link contains article tokens so it's an article page
  const link = window.location.pathname;

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {link.startsWith("/cml-test/") || link.indexOf("/featured-insights/mckinsey-explainers/") !== -1 ? <AppArticle/> : <App />}
    </Suspense>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DataPointsEntry />
  </React.StrictMode>
);
